import {Interval} from '@product-web/api-types/billing'

export const billingPeriodIntervalStrings = {
    month: Interval.MONTH.toString(),
    year: Interval.YEAR.toString(),
    day: Interval.DAY.toString(),
    week: Interval.WEEK.toString(),
}
